<template>
  <div class="px-4 ml-6 py-4 layout-row layout-wrap">

    <!-- Kopfdaten -->

    <div class="flex-gt-sm-100 flex-100 mt-2">
      <div class="flex-100 px-3 py-1 mb-3 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.REPORTER_PERSONAL_CONTRIBUTION') }}</span>
      </div>

      <melder path="headerData"
              v-model="model.headerData"
              :formKey="model.formType"
              :additionalItemsList="additionalItemsList"
              :validationRef="validationRef"
              :isImport="true"
              :disableManuallyValidate="true"
      ></melder>
    </div>

    <!-- Grunddaten -->

    <div class="flex-100 px-3 py-1 my-6 mx-2"
         :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
         style="border-radius: 4px;">
      <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.BASE_PROGRESS_SUB_LINE') }}</span>
    </div>

    <!-- Grund für Ende  -->

    <div class="flex-gt-sm-50 flex-100 px-2" v-if="model.reportType==='behandlungsende'">
      <validation-provider tag="div"
                           :name="path + '.additionalFields.radiationTherapy.st_ende_grund'"
                           :ref="path + '.additionalFields.radiationTherapy.st_ende_grund'"
                           rules="required"
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_RADIATION_REASON_END') + ' *'"
          v-model="model.additionalFields.radiationTherapy.st_ende_grund"
          :items="stEndeGrundTypes"
          outlined
          :dense="denseFields"
          :hide-details="!errors || errors.length <= 0"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- Datum Beginn wenn Therapieende, ansonsten ist model.date Datum Beginn -->

    <div class="flex-100 px-2 mb-6" v-if="model.reportType==='behandlungsende'">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_BEGINN_OF_THERAPY')">
        <div class="layout-row px-3 py-2 layout-wrap">

          <!-- Soll verlinkt werden ? -->

          <div class="flex-100 mb-2 layout-row">
            <v-radio-group :dense="denseFields" v-model="isLinkedTherapy" row hide-details
                           class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_SYST_LABEL_END_THERAPY_LINK')"
                       :disabled="listOfUnlinkedTherapies.length === 0"
                       value="J" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_SYST_LABEL_END_THERAPY_MANUALLY_INPUT')"
                       @change="unlinkTherapy"
                       value="N" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
            </v-radio-group>
          </div>

          <!-- Beginn der Bestrahlung -->

          <div class="flex-gt-sm-50 flex-100 px-1" v-show="isLinkedTherapy !== 'J'">
            <validation-provider tag="div"
                                 :name="path + '.additionalFields.radiationTherapy.bestrahlung.0.st_beginn_datum'"
                                 :ref="path + '.additionalFields.radiationTherapy.bestrahlung.0.st_beginn_datum'"
                                 :rules="{required:true,german_date:true,date_not_in_future:true,date_must_be_lesser_than:date,date_must_be_greater_than_diagnosis:diagDate,date_must_be_lesser_than_death:[deathOfDeath,null]}"
                                 v-slot="{ errors }">
              <lx-datepicker
                :color="compColor.textInput"
                :name="path + '.additionalFields.radiationTherapy.bestrahlung.st_beginn_datum'"
                :label="$t('FORMS_DIVERSE.MODULE_RADIATION_DATE_START') + ' *'"
                class="mb-4"
                @input="updateStartDatesAfterChange()"
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :error="errors[0]"
                v-model="model.additionalFields.radiationTherapy.bestrahlung[0].st_beginn_datum"
              ></lx-datepicker>
            </validation-provider>
          </div>

          <!-- Verlinkter Therapiebeginn -->

          <div class="flex-gt-sm-50 flex-100 px-1 mt-2" v-show="isLinkedTherapy === 'J'">
            <validation-provider tag="div"
                                 :name="path + '.linked_therapy'"
                                 :ref="path + '.linked_therapy'"
                                 :rules="{required: isLinkedTherapy === 'J'}"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_LINKED_THERAPY') + ' *'"
                v-model="model.linked_therapy"
                :items="listOfUnlinkedTherapies"
                outlined
                @change="setBaseDataOfLinkedTherapy"
                item-value="_id"
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:selection='{ item }'>
                  <label :style="{'font-size': denseFields ? '14.4px !important' : '16px !important'}">
                    {{ formatDateOfRadiationTherapy(item) }}
                  </label>
                </template>
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ formatDateOfRadiationTherapy(item) }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>

          <div v-if="!!model.linked_therapy && model.reportType === 'behandlungsbeginn'" class="flex-gt-sm-100 pa-3 mb-2 ml-1 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
               :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
               :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
            <div class="layout-column layout-align-center-center mr-3">
              <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
            </div>
            <span style="font-size: 14px;" v-bind:class="compColor.primeClass">{{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_LINKED_THERAPY_MESSAGE') }}</span>
          </div>

          <div v-if="isLinkedTherapy === 'J' && model.reportType === 'behandlungsende'" class="flex-gt-sm-100 pa-3 mb-2 mx-1 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
               :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
               :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
            <div class="layout-column layout-align-center-center mr-3">
              <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
            </div>
            <span style="font-size: 14px;" v-bind:class="compColor.primeClass">{{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_LINKED_THERAPY_MESSAGE_IMPORT') }}</span>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <!-- Intension der Bestrahlung -->

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.additionalFields.radiationTherapy.st_intention'"
                           :ref="path + '.additionalFields.radiationTherapy.st_intention'"
                           rules="required"
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_SYST_INTENTION') + ' *'"
          v-model="model.additionalFields.radiationTherapy.st_intention"
          :items="stIntentionTypes"
          outlined
          :dense="denseFields"
          :hide-details="!errors || errors.length <= 0"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- Stellung zur OP -->

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.additionalFields.radiationTherapy.st_stellung_op'"
                           :ref="path + '.additionalFields.radiationTherapy.st_stellung_op'"
                           rules="required"
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_RADIATION_POSITION_TO_OP') + ' *'"
          v-model="model.additionalFields.radiationTherapy.st_stellung_op"
          :items="stStellungOpTypes"
          outlined
          :dense="denseFields"
          :hide-details="!errors || errors.length <= 0"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- BUTTON ADD SINGLE RADIATION -->

    <div v-bind:style="{'z-index': '4'}" class="layout-align-start-center pa-2">
      <lx-btn icon="add_circle"
              :color="compColor.primeColor"
              :iconColor="'white'"
              :tooltip="$t('FORMS_DIVERSE.MODULE_RADIATION_TOOLTIP_ADD_BTN')"
              :label="$t('FORMS_DIVERSE.MODULE_RADIATION_ADD_RADIATION')"
              iconSize="21"
              :width="'auto'"
              :height="35"
              :disabled="Boolean(model.linked_therapy)"
              classes="text-none"
              @click="addNewRadiation()"
      ></lx-btn>
    </div>

    <v-divider class="mx-3 flex-gt-sm-100 flex-100 my-1" v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

    <!-- Applikationsart -->

    <div :key="index" v-for="(item, index) in this.model.additionalFields.radiationTherapy.bestrahlung"
         class="layout-row flex-gt-sm-100 pa-0 ma-2 flex"
         :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
         style="border-radius:4px;"
         :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

      <div class="flex-100 px-2 mb-4">
        <div class="layout layout-column mb-4">
          <div class="flex-gt-sm-100 flex-100 px-2 mt-2 layout layout-row layout-wrap">
            <validation-provider tag="div"
                                 class="flex-gt-sm-50 flex-100 my-2"
                                 :name="path + '.additionalFields.radiationTherapy.bestrahlung' + '.' + index + '.selectedKindOfApplication'"
                                 :ref="path + '.additionalFields.radiationTherapy.bestrahlung.' + '.' + index + '.selectedKindOfApplication'"
                                 rules="required">
              <v-btn-toggle v-model="item.selectedKindOfApplication"
                            dense
                            :mandatory="!!item.selectedKindOfApplication"
                            class="ml-2"
                            style="margin-top:2px;"
                            :color="compColor.prime">
                <v-btn :key="listIndex" v-for="(kind, listIndex) in listOfApplications" :value="kind.value"
                       @click="setKindOfApplication(kind.value, index)">
                  {{ kind.text }}
                </v-btn>
              </v-btn-toggle>
            </validation-provider>

            <!-- Datum Ende der Bestrahlung -->

            <div class="flex-gt-sm-50 flex-100 pl-2 pr-1 mt-2" v-if="model.reportType === 'behandlungsende'">
              <validation-provider tag="div"
                                   :name="path + '.additionalFields.radiationTherapy.bestrahlung' + '.' + index + '.st_ende_datum'"
                                   :ref="path + '.additionalFields.radiationTherapy.bestrahlung.' + '.' + index + '.st_ende_datum'"
                                   :rules="{
                                     required:true,
                                     german_date:true,
                                     date_not_in_future:true,
                                     date_must_be_greater_than:item.st_beginn_datum,
                                     date_must_be_greater_than_diagnosis:diagDate,
                                     date_must_be_lesser_than_death:[deathOfDeath, null],
                                     date_must_be_lesser_than_lead_date:date
                                   }"
                                   v-slot="{ errors }">
                <lx-datepicker
                    :color="compColor.textInput"
                    :name="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_ende_datum'"
                    :label="$t('FORMS_DIVERSE.MODULE_RADIATION_DATE_END') + ' *'"
                    class="mb-4"
                    :dense="denseFields"
                    :hide-details="!errors || errors.length <= 0"
                    :error="errors[0]"
                    v-model="item.st_ende_datum"
                ></lx-datepicker>
              </validation-provider>
            </div>
          </div>

          <!-- Applikationsart  Unterelemente -->

          <div v-if="item.selectedKindOfApplication" class="layout-row layout-wrap flex-100 ml-2 mb-4">
            <div class="flex mb-2 pl-2" style="min-width: 220px;">
              <div class="pr-2 py-1" :key="typeParentIndex" v-for="(type, typeParentIndex) in stApplikationsartTypes[item.selectedKindOfApplication].types">
                <label v-if="type.text" style="font-style: italic;" :style="{ 'color': compColor.isInDarkMode ? '#cfd8dc' : ''}">{{ type.text }}</label>
                <validation-provider tag="div"
                                     :name="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' +  item.selectedKindOfApplication + '.' + type.value"
                                     :ref="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' +  item.selectedKindOfApplication + '.' + type.value"
                                     :rules="{ required: type.required }"
                                     v-slot="{ errors }">
                  <v-radio-group :dense="denseFields"
                                 v-model="item.st_applikationsart[item.selectedKindOfApplication][type.value]"
                                 :error-messages="errors[0]"
                                 :hide-details="!errors || errors.length <= 0"
                                 class="mx-0 pa-0 my-2"
                                 :dark="compColor.isInDarkMode"
                                 style="flex:unset;margin-top: 10px;">
                    <v-radio :key="typeIndex" v-for="(elem, typeIndex) in type.list"
                             :label="elem.text"
                             style="font-size: 15px;"
                             :value="elem.value" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                    </v-radio>
                  </v-radio-group>
                </validation-provider>
              </div>

              <!-- Reset kind of application via button  -->

              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                     :class="denseFields ? 'pl-2' : ''"
                     @click="resetKindOfApplication(index)"
                     v-show="getLengthOfSelectedKindOfApplication(index).length > 0 && !stApplikationsartTypes[item.selectedKindOfApplication].required"
                     :title="$t('buttons.deleteSelection.title')">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass"
                        size="24">mdi-arrow-up-bold
                </v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </div>
          </div>
        </div>

        <div class="layout row layout-wrap px-4 pb-3">

          <!-- Strahlenart -->

          <div class="flex-gt-sm-100 flex-100 px-2" v-if="item.selectedKindOfApplication && item.selectedKindOfApplication!=='sonstige'">
            <validation-provider tag="div"
                                 :name="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.strahlenart'"
                                 :ref="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.strahlenart'"
                                 rules=""
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="$t('FORMS_DIVERSE.MODULE_RADIATION_KIND_OF_RADIATION')"
                v-model="item.st_applikationsart[item.selectedKindOfApplication].strahlenart"
                :items="stApplikationsartTypes[item.selectedKindOfApplication].strahlenart"
                outlined
                clearable
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>

          <!-- Zielgebiet der Bestrahlung -->

          <div class="flex-gt-sm-50 flex-100 px-2 layout-row" v-if="item.selectedKindOfApplication">
            <validation-provider tag="div"
                                 :name="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.zielgebiet.' + item.selectedVersionOfDestination"
                                 :ref="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.zielgebiet.' + item.selectedVersionOfDestination"
                                 rules="required"
                                 class="flex"
                                 v-slot="{ errors }">
              <v-autocomplete
                :color="compColor.primeColor"
                v-model="item.st_applikationsart[item.selectedKindOfApplication].zielgebiet[item.selectedVersionOfDestination]"
                outlined
                :dense="denseFields"
                @change="deleteSideOfDestination(index)"
                :hide-details="!errors || errors.length <= 0"
                :label="$t('FORMS_DIVERSE.MODULE_RADIATION_DESTINATION') + ' *'"
                :error-messages="errors[0]"
                :dark="compColor.isInDarkMode"
                :items="getSTZielgebietList(index)">
                <template v-slot:no-data>
                  <div class="layout-row pt-1 pb-1 pl-3 pr-3">
                    <div class="flex layout-row mr-3 lighten-4 text--darken-2"
                         :class="compColor.isInDarkMode ? ['white--text'] : []"
                         :style="{'font-size': denseFields ? '14.4px !important' : '16px !important'}">
                      {{ $t('NO_SEARCH_RESULT') }}
                    </div>
                  </div>
                </template>
                <template v-slot:item="{item, on, parent, attrs}">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0 layout-row">
                      <div  class="py-0 layout-row">
                        <lx-text-highlight :text="item.text" :search-string="parent._props.searchInput"
                                           :color="compColor.prime"></lx-text-highlight>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </validation-provider>

            <!-- Version Zielgebiet der Bestrahlung -->

            <div class="layout-column pt-0">
              <label style="font-size: 12px" class="pt-0 mt-n1 pl-2 layout-align-center-center layout-row">{{ $t('FORMS_DIVERSE.MODULE_RADIATION_DESTINATION_VERSION') }}</label>
              <v-btn-toggle v-model="item.selectedVersionOfDestination"
                            dense
                            :mandatory="!!item.selectedVersionOfDestination"
                            class="ml-2"
                            :color="compColor.prime">
                <v-btn value="code_version_2014"
                       height="25"
                       @click="deleteValuesOfDestination('code_version_2021', index)">
                  2014
                </v-btn>
                <v-btn value="code_version_2021"
                       height="25"
                       @click="deleteValuesOfDestination('code_version_2014', index)">
                  2021
                </v-btn>
              </v-btn-toggle>
            </div>
          </div>

          <!-- Seite des Zielgebietes der Bestrahlung -->

          <div class="flex-gt-sm-50 flex-100 px-2" v-if="item.selectedKindOfApplication">
            <validation-provider tag="div"
                                 :name="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.seite_zielgebiet'"
                                 :ref="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.seite_zielgebiet'"
                                 rules="required"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="$t('FORMS_DIVERSE.MODULE_RADIATION_DESTINATION_SIDE') + ' *'"
                v-model="item.st_applikationsart[item.selectedKindOfApplication].seite_zielgebiet"
                :items="getSTZielgebietSeiteList(index)"
                outlined
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>

          <!-- Gesamtdosis Wert -->

          <div class="flex-gt-sm-50 flex-100 px-2" v-if="item.selectedKindOfApplication && model.reportType === 'behandlungsende'">
            <validation-provider tag="div"
                                 :name="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.gesamtdosis.dosis'"
                                 :ref="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.gesamtdosis.dosis'"
                                 :rules="{decimal:1,min_value:0.1,required:true,overall_dosage_must_be_greater_than_single_dosage:[item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.dosis]}"
                                 v-slot="{ errors }">
              <lx-numberfield :dense="denseFields"
                              :hide-details="!errors || errors.length <= 0"
                              v-model="item.st_applikationsart[item.selectedKindOfApplication].gesamtdosis.dosis"
                              @input="setUnitAfterDosage(item.st_applikationsart[item.selectedKindOfApplication].gesamtdosis.dosis, index, 'gesamtdosis')"
                              :label="formatRequiredLabel('FORMS_DIVERSE.MODULE_RADIATION_TOTAL_DOSE')"
                              separator=","
                              :error-messages="errors[0]"
              ></lx-numberfield>
            </validation-provider>
          </div>

          <!-- Gesamtdosis Einheit -->

          <div class="flex-gt-sm-50 flex-100 px-2" v-if="item.selectedKindOfApplication && model.reportType === 'behandlungsende'">
            <validation-provider tag="div"
                                 :name="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.gesamtdosis.einheit'"
                                 :ref="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.gesamtdosis.einheit'"
                                 :rules="{required: model.reportType==='behandlungsende'}"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="formatRequiredLabel('FORMS_DIVERSE.MODULE_RADIATION_UNIT_TOTAL_DOSE')"
                v-model="item.st_applikationsart[item.selectedKindOfApplication].gesamtdosis.einheit"
                :items="stApplikationsartTypes[item.selectedKindOfApplication].units"
                outlined
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>

          <!-- Einzeldosis Wert -->

          <div class="flex-gt-sm-50 flex-100 px-2" v-if="item.selectedKindOfApplication">
            <validation-provider tag="div"
                                 :name="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.einzeldosis.dosis'"
                                 :ref="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.einzeldosis.dosis'"
                                 :rules="{decimal:1, min_value:0.1,required:model.reportType==='behandlungsende' || !!(item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.einheit),single_dosage_must_be_lesser_than_overall_dosage:[item.st_applikationsart[item.selectedKindOfApplication].gesamtdosis.dosis]}"
                                 v-slot="{ errors }">
              <lx-numberfield :dense="denseFields"
                              v-model="item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.dosis"
                              @input="setUnitAfterDosage(item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.dosis, index,'einzeldosis')"
                              :label="formatRequiredLabel('FORMS_DIVERSE.MODULE_RADIATION_SINGLE_DOSE', item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.einheit)"
                              separator=","
                              :hide-details="!errors || errors.length <= 0"
                              :error-messages="errors[0]"
              ></lx-numberfield>
            </validation-provider>
          </div>

          <!-- Einzeldosis Einheit -->

          <div class="flex-gt-sm-50 flex-100 px-2" v-if="item.selectedKindOfApplication">
            <validation-provider tag="div"
                                 :name="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.einzeldosis.einheit'"
                                 :ref="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.einzeldosis.einheit'"
                                 :rules="{required: !!item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.dosis}"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="formatRequiredLabel('FORMS_DIVERSE.MODULE_RADIATION_UNIT_SINGLE_DOSE', item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.dosis)"
                v-model="item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.einheit"
                :items="stApplikationsartTypes[item.selectedKindOfApplication].units"
                outlined
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>

          <!-- Boost -->

          <div class="flex-gt-sm-100 flex-100 px-2" v-if="item.selectedKindOfApplication && stApplikationsartTypes[item.selectedKindOfApplication].boost">
            <validation-provider tag="div"
                                 :name="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.boost'"
                                 :ref="path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.boost'"
                                 rules=""
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="$t('FORMS_DIVERSE.MODULE_RADIATION_BOOST')"
                v-model="item.st_applikationsart[item.selectedKindOfApplication].boost"
                :items="boostTypes"
                outlined
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>
        </div>
      </div>

      <!-- DELETE BUTTON -->

      <div class="layout-column layout-align-center-center px-3"
           :class="{'grey lighten-2': !compColor.isInDarkMode}"
           :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
        <lx-btn @click="deleteRadiation(index, path + '.additionalFields.radiationTherapy.bestrahlung.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.boost')"
                :color="compColor.primeColor"
                :iconColor="'white'"
                :tooltip="$t('FORMS_DIVERSE.MODULE_RADIATION_TOOLTIP_DELETE_BTN')"
                iconSize="21"
                :width="35"
                :height="35"
                :disabled="(model.additionalFields.radiationTherapy.bestrahlung && model.additionalFields.radiationTherapy.bestrahlung.length === 1) || Boolean(model.linked_therapy)"
                icon="delete_forever">
        </lx-btn>
      </div>
    </div>

    <!--  CTCAE  -->

    <div class="flex-100 px-2 mb-3">
      <fake-input-frame :label="formatRequiredLabel('FORMS_DIVERSE.MODULE_CTCAE_HEADER')">
        <nebenwirkungen path="additionalFields.radiationTherapy.st_nebenwirkung"
                        :addCtcaeItem="addItem"
                        :deleteCtcaeItem="deleteItem"
                        :isRequired="true"
                        v-model="model.additionalFields.radiationTherapy.st_nebenwirkung"
                        :validationRef="validationRef"
                        class="layout-row layout-wrap flex-gt-sm-100 flex-100"></nebenwirkungen>
      </fake-input-frame>
    </div>

    <!--  ANMERKUNG  -->

    <div class="flex-gt-sm-100 flex-100 mt-3">
      <div class="flex-100 px-3 py-1 mb-6 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.ANNOTATION_HEADER') }}</span>
      </div>

      <anmerkung path="additionalFields.radiationTherapy.anmerkung"
                 :isDisabled="isFormDisabled()"
                 v-model="model.additionalFields.radiationTherapy.anmerkung"
                 class="layout-wrap flex-gt-sm-100 flex-100"></anmerkung>
    </div>
  </div>
</template>

<script>
import utils from '../../../common/utils'
import metaData from '../../../components/documentation/shared/formsMetaData'

import nebenwirkungen from '../../../components/documentation/shared/Nebenwirkungen'
import Melder from '../../../components/documentation/shared/Melder'
import moment from 'moment'
import lodash from 'lodash'
import Anmerkung from '../../../components/documentation/shared/Anmerkung.vue'

export default {
  name: "RadiationTherapy",
  mixins: [metaData, utils],
  components: {
    Anmerkung,
    Melder,
    nebenwirkungen
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        additionalFields: {
          radiationTherapy: {
            bestrahlung: {},
            st_nebenwirkung: {}
          }
        }
      })
    },
    path: {
      type: String
    },
    date: {
      type: [Object, String]
    },
    icd: {
      type: Object,
      default: () => ({})
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    recentForms: {
      type: Array,
      default: () => ([])
    },
    unlinkedRecentRadiationTherapies: {
      type: Array,
      default: () => ([])
    },
    additionalItemsList: {
      type: Array,
      default: () => ([])
    },
    deathOfDeath: {
      type: String
    },
    diagDate: {
      type: [Object, String]
    }
  },
  data () {
    return {
      model: {
        additionalFields: {
          radiationTherapy: {
            bestrahlung: [{}]
          }
        }
      },
      einheitTypes: [],
      stApplikationsartTypes: [],
      stEndeGrundTypes: [],
      stIntentionTypes: [],
      stSeiteZielgebietTypes: [],
      stSeiteZielgebietTypes_onlyLR: [],
      stStellungOpTypes: [],
      stZielgebietTypes_2014: [],
      stZielgebietTypes_2021: [],
      boostTypes: [],
      listOfApplications: [
        { value: 'perkutan', text: 'Perkutan'},
        { value: 'kontakt', text: 'Kontakt'},
        { value: 'metabolisch', text: 'Metabolisch'},
        { value: 'sonstige', text: 'Sonstige'}
      ],
      isLinkedTherapy: false
    }
  },
  created () {
    this.einheitTypes = this.formsMetaData.EinheitTypes
    this.stApplikationsartTypes = this.formsMetaData.ST_ApplikationsartTypes
    this.stEndeGrundTypes = this.formsMetaData.ST_Ende_GrundTypes
    this.stIntentionTypes = this.formsMetaData.ST_IntentionTypes
    this.stZielgebietTypes_2014 = this.formsMetaData.ST_ZielgebietTypes2014
    this.stZielgebietTypes_2021 = this.formsMetaData.ST_ZielgebietTypes2021
    this.stSeiteZielgebietTypes = this.formsMetaData.ST_Seite_ZielgebietTypes
    this.stSeiteZielgebietTypes_onlyLR = this.formsMetaData.ST_Seite_ZielgebietTypes_onlyLR
    this.stStellungOpTypes = this.formsMetaData.ST_Stellung_OPTypes
    this.boostTypes = this.formsMetaData.BoostTypes
  },
  methods: {
    /**
     * Check if one or more kind of application in a single radiation are selected to show/hide clear-button
     *
     * @param index The index of selected single radiation
     * @returns {*[]}
     */
    getLengthOfSelectedKindOfApplication (index) {
      let kindOfApplicationsArray = []

      if (this.model.additionalFields.radiationTherapy.bestrahlung[index] && this.stApplikationsartTypes[this.model.additionalFields.radiationTherapy.bestrahlung[index].selectedKindOfApplication].types) {
        this.stApplikationsartTypes[this.model.additionalFields.radiationTherapy.bestrahlung[index].selectedKindOfApplication].types.forEach(type => {
          if (this.model.additionalFields.radiationTherapy.bestrahlung[index] && this.model.additionalFields.radiationTherapy.bestrahlung[index].st_applikationsart[this.model.additionalFields.radiationTherapy.bestrahlung[index].selectedKindOfApplication][type.value]) {
            kindOfApplicationsArray.push(this.model.additionalFields.radiationTherapy.bestrahlung[index].st_applikationsart[this.model.additionalFields.radiationTherapy.bestrahlung[index].selectedKindOfApplication][type.value])
          }
        })
      }

      return kindOfApplicationsArray
    },

    /**
     * Return list of destination of radiation to each single radiation in dependency to selected version
     *
     * @param index The index of selected radiation
     * @returns {*[]|*}
     */
    getSTZielgebietList (index) {
      return !this.model.additionalFields.radiationTherapy.bestrahlung[index].selectedVersionOfDestination || this.model.additionalFields.radiationTherapy.bestrahlung[index].selectedVersionOfDestination === 'code_version_2021' ? this.stZielgebietTypes_2021 : this.stZielgebietTypes_2014
    },

    /**
     * Return list of side location of destination to each single radiation in dependency to destination and version
     *
     * @param index The index of selected radiation
     * @returns {null}
     */
    getSTZielgebietSeiteList (index) {
      const selectedKindOfApplication = this.model.additionalFields.radiationTherapy.bestrahlung[index].selectedKindOfApplication
      const destination = this.model.additionalFields.radiationTherapy.bestrahlung[index].st_applikationsart[selectedKindOfApplication].zielgebiet.code_version_2021
      const isLROnly = this.stZielgebietTypes_2021.find(elem => elem.value === destination)

      return this.model.additionalFields.radiationTherapy.bestrahlung[index].selectedVersionOfDestination === 'code_version_2021' && isLROnly && isLROnly.onlyLR ? this.stSeiteZielgebietTypes_onlyLR : this.stSeiteZielgebietTypes
    },

    /**
     * Delete actually properties of destination after switching version of destination
     *
     * @param destinationToDelete The name of the destination version from which was switched to new version
     * @param index The index of selected single radiation
     */
    deleteValuesOfDestination (destinationToDelete, index) {
      const selectedKindOfApplication = this.model.additionalFields.radiationTherapy.bestrahlung[index].selectedKindOfApplication

      // delete destination property e.g. code_version_2014
      this.$delete(this.model.additionalFields.radiationTherapy.bestrahlung[index].st_applikationsart[selectedKindOfApplication].zielgebiet, destinationToDelete)

      // delete side of destination, if it is not part of new list
      if (destinationToDelete === 'code_version_2014') {
        this.deleteSideOfDestination(index)
      }
    },

    /**
     * Delete side of destination if not part of list
     *
     * @param index The index of selected single radiation
     */
    deleteSideOfDestination (index) {
      const selectedKindOfApplication = this.model.additionalFields.radiationTherapy.bestrahlung[index].selectedKindOfApplication
      const sideOfDestination = this.model.additionalFields.radiationTherapy.bestrahlung[index].st_applikationsart[selectedKindOfApplication].seite_zielgebiet
      const ST_ZielgebietSeiteList = this.getSTZielgebietSeiteList(index)

      if (sideOfDestination && !ST_ZielgebietSeiteList.find(elem => elem.value === sideOfDestination)) {
        this.$delete(this.model.additionalFields.radiationTherapy.bestrahlung[index].st_applikationsart[selectedKindOfApplication], 'seite_zielgebiet')
      }
    },

    /**
     * Reset selected radio-button of kind of application and trigger dirty flag of validator for save
     *
     * @param index The index of selected single radiation
     */
    resetKindOfApplication (index) {
      // delete all selected sub elements of selected kind of application
      const selectedKindOfApplication = this.model.additionalFields.radiationTherapy.bestrahlung[index].selectedKindOfApplication
      const applicationTypes = this.stApplikationsartTypes[selectedKindOfApplication].types || []

      applicationTypes.forEach(type => {
        this.$delete(this.model.additionalFields.radiationTherapy.bestrahlung[index].st_applikationsart[selectedKindOfApplication], type.value)
      })

      // set dirty flag of first element of selected kind of application and trigger save
      const firstElement = this.stApplikationsartTypes[selectedKindOfApplication]?.types[0]?.value ? this.stApplikationsartTypes[selectedKindOfApplication].types[0].value : ''
      this.validationRef.fields[this.path + '.additionalFields.radiationTherapy.bestrahlung' + '.'+ index + '.st_applikationsart.' +  selectedKindOfApplication + '.' + firstElement].changed = true
    },

    /**
     * Set unit of dosage automatically, if kind of application is perkutan or kontakt
     *
     * @param dosage The value of the selected dosage
     * @param radiationIndex The index of selected single radiation
     * @param field The name of selected field (e.g. gesamtdosis)
     */
    setUnitAfterDosage (dosage, radiationIndex, field) {
      const selectedKindOfApplication = this.model.additionalFields.radiationTherapy.bestrahlung[radiationIndex].selectedKindOfApplication

      if (selectedKindOfApplication === 'perkutan' || selectedKindOfApplication === 'kontakt' || selectedKindOfApplication === 'sonstige') {
        this.$set(this.model.additionalFields.radiationTherapy.bestrahlung[radiationIndex].st_applikationsart[selectedKindOfApplication][field], 'einheit', dosage ? 'Gy' : null)
      }

      // delete unit after manually deleting dosage, if kind of application is metabolisch
      if (selectedKindOfApplication === 'metabolisch' && !dosage) {
        this.$set(this.model.additionalFields.radiationTherapy.bestrahlung[radiationIndex].st_applikationsart[selectedKindOfApplication][field], 'einheit', null)
      }
    },

    /**
     * Update all other start dates in list of radiation, if date of first radiation has changes
     */
    updateStartDatesAfterChange () {
      if (this.model.additionalFields.radiationTherapy.bestrahlung && this.model.additionalFields.radiationTherapy.bestrahlung.length > 1) {

        this.$nextTick(() => {
          this.model.additionalFields.radiationTherapy.bestrahlung.forEach((radiation) => {
            this.$set(radiation, 'st_beginn_datum', this.model.reportType === 'behandlungsende' ? this.model.additionalFields.radiationTherapy.bestrahlung[0].st_beginn_datum : this.date)
          })
        })
      }
    },

    /**
     * Add new single radiation to radiation list
     */
    addNewRadiation () {
      let radiation = {
        st_beginn_datum: this.model.additionalFields.radiationTherapy.bestrahlung[0].st_beginn_datum,
        selectedKindOfApplication: 'perkutan',
        selectedVersionOfDestination: 'code_version_2021',
        st_applikationsart: {
          perkutan: {
            zielgebiet: {},
            gesamtdosis: {},
            einzeldosis: {}
          }
        }
      }

      // set import date es default for st_ende_datum, if report reason is 'behandlungsende'
      if (this.model.reportType === 'behandlungsende') {
        radiation.st_ende_datum = this.date
      }

      this.$set(this.model.additionalFields.radiationTherapy.bestrahlung, this.model.additionalFields.radiationTherapy.bestrahlung.length, radiation)
    },

    /**
     * Delete selected single radiation
     *
     * @param index The index of selected radiation
     * @param field The field name to trigger validator and auto-save
     */
    deleteRadiation (index, field) {
      this.$delete(this.model.additionalFields.radiationTherapy.bestrahlung, index)
      this.validationRef.fields[field].changed = true
    },

    /**
     * Delete linked therapy, when start date should be set manually and trigger save
     */
    unlinkTherapy () {
      this.$delete(this.model, 'linked_therapy')
    },

    /**
     * Set value selectedKindOfApplication when triggering btn-group
     *
     * @param value The selected value
     * @param radiationIndex The index of selected single radiation
     */
    setKindOfApplication (value, radiationIndex) {
      // reset kind of application only, ich new kind is selected e.g. perkutan -> kontakt
      if (Object.keys(this.model.additionalFields.radiationTherapy.bestrahlung[radiationIndex].st_applikationsart).indexOf(value) < 0) {
        this.$set(this.model.additionalFields.radiationTherapy.bestrahlung[radiationIndex], 'selectedKindOfApplication', value)
        this.$set(this.model.additionalFields.radiationTherapy.bestrahlung[radiationIndex], 'st_applikationsart', {})
        this.$set(this.model.additionalFields.radiationTherapy.bestrahlung[radiationIndex].st_applikationsart, this.model.additionalFields.radiationTherapy.bestrahlung[radiationIndex].selectedKindOfApplication, {zielgebiet: {}, gesamtdosis: {}, einzeldosis: {}})
      }
    },

    /**
     * Return label with required-star of field in dependency to report reason
     *
     * @param text The selected text of label
     * @param dependency The field selected element depends on
     *
     * @returns {VueI18n.TranslateResult}
     */
    formatRequiredLabel (text, dependency) {
      let label = this.$t(text)

      if (this.model.reportType==='behandlungsende' || Boolean(dependency)) label += ' *'

      return label
    },

    /**
     * Set base date af therapy with "behandlungsende" after link to start therapy
     */
    setBaseDataOfLinkedTherapy () {
      const selectedForm = this.listOfUnlinkedTherapies.find(form => form._id === this.model.linked_therapy)

      if (selectedForm) {
        let radiation = lodash.cloneDeep(selectedForm.applikationsart)

        radiation.forEach(element => {
          element.st_ende_datum = this.date

          element.selectedKindOfApplication = Object.keys(element.st_applikationsart)[0]
          // set value of radio-group of version of destination
          if (element.st_applikationsart[element.selectedKindOfApplication] && element.st_applikationsart[element.selectedKindOfApplication].zielgebiet) {
            element.selectedVersionOfDestination = Object.keys(element.st_applikationsart[element.selectedKindOfApplication].zielgebiet)[0] || 'code_version_2021'
          }
        })

        this.$set(this.model.additionalFields.radiationTherapy, 'bestrahlung', radiation)
        this.$set(this.model.additionalFields.radiationTherapy, 'st_intention', selectedForm.st_intention)
        this.$set(this.model.additionalFields.radiationTherapy, 'st_stellung_op', selectedForm.st_stellung_op)

        setTimeout(() => {
          if (this.validationRef) Array.isArray(this.validationRef) ? this.validationRef[0].validate() : this.validationRef.validate()
        }, 200)
      }
    }
  },
  computed: {
    listOfUnlinkedTherapies () {
      let therapyList = this.unlinkedRecentRadiationTherapies.filter(therapy => {
        return therapy.diagnosis_id === this.model.diagnosis && // therapy start must have same diagnosis
          (moment(this.date).isSame(therapy.date, 'day') || moment(this.date).isAfter(therapy.date, 'day')) // therapy start must be older
      })

      if (this.model.reportType === 'behandlungsende' && !this.model.linked_therapy) {
        return therapyList
      } else if (this.model.reportType === 'behandlungsende' && this.model.linked_therapy) {
        const selectedStartTherapy = this.recentForms.find(therapy => therapy.uuid === this.model.linked_therapy)

        // add linked therapy start t list of unlinked therapies to show in select-element
        if (selectedStartTherapy) {
          let listElement = {
            _id: selectedStartTherapy.uuid,
            applikationsart: selectedStartTherapy.additionalFields.radiationTherapy.bestrahlung,
            st_intention: selectedStartTherapy.additionalFields.radiationTherapy.st_intention,
            st_stellung_op: selectedStartTherapy.additionalFields.radiationTherapy.st_stellung_op,
            date: selectedStartTherapy.date
          }

          const diagnosis = this.recentForms.find(elem => {
            return (elem.uuid && elem.uuid === selectedStartTherapy.diagnosis) || (elem.subjId && elem.subjId === selectedStartTherapy.subjId)
          })

          if (diagnosis?.uuid) {
            listElement.diagnosis_id = diagnosis.uuid
          }

          therapyList.unshift(listElement)
        }

        return therapyList
      } else {
        return []
      }
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue && oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
          this.isLinkedTherapy = this.model.reportType === 'behandlungsende' && this.model.linked_therapy ? 'J' : 'N'

          if (!this.model.additionalFields) {
            this.$set(this.model, 'additionalFields', {
              radiationTherapy: {
                bestrahlung: [
                  {
                    st_applikationsart: {
                      perkutan: {
                        zielgebiet: {},
                        gesamtdosis: {},
                        einzeldosis: {}
                      }
                    }
                  }
                ]
              }
            })
          }

          // set value of radio-group of kind of application
          if (this.model.additionalFields.radiationTherapy.bestrahlung && this.model.additionalFields.radiationTherapy.bestrahlung.length > 0) {
            this.model.additionalFields.radiationTherapy.bestrahlung.forEach((element) => {
              element.selectedKindOfApplication = Object.keys(element.st_applikationsart)[0]
              // set value of radio-group of version of destination
              if (element.st_applikationsart[element.selectedKindOfApplication] && element.st_applikationsart[element.selectedKindOfApplication].zielgebiet) {
                element.selectedVersionOfDestination = Object.keys(element.st_applikationsart[element.selectedKindOfApplication].zielgebiet)[0] || 'code_version_2021'
              }
            })
          }
        }
      },
      immediate: true
    },
    'model.diagnosis': {
      handler: function (newValue, oldValue) {
        // delete linked therapy after changing diagnosis
        if (this.model.linked_therapy && newValue && oldValue && newValue !== oldValue) {
          this.unlinkTherapy()
          this.isLinkedTherapy = 'N'
        }
      },
      immediate: true
    },
    date: {
      handler: function (newValue,) {
        if (newValue && this.model.reportType === 'behandlungsbeginn') {
          this.updateStartDatesAfterChange()
        }
      },
      immediate: true
    }
  }
}
</script>
